__webpack_require__.p = "/shared-mailbox-aa/referrals-hub/";